import { render } from "./PlayerExt.vue?vue&type=template&id=15730963&scoped=true"
import script from "./PlayerExt.vue?vue&type=script&lang=js"
export * from "./PlayerExt.vue?vue&type=script&lang=js"

import "./PlayerExt.vue?vue&type=style&index=0&id=15730963&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15730963"]])

export default __exports__